import { Stack, Text } from '@ltvco/refresh-lib/theme';
import {
  ReportColumnContainer,
  CHATAI_GA4_EVENTS,
  SEARCH_TYPES,
  ReportResponse,
} from '@ltvco/refresh-lib/v2';
import {
  AppConfig,
  ChatBVProvider,
  ReportContextProvider,
} from '@ltvco/refresh-lib/ctx';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import CloseIcon from '@mui/icons-material/Close';
import { useScreenSize } from '@ltvco/refresh-lib/utils';
import { constants } from 'appConstants';
import { useContext } from 'react';
import { VehicleReport } from 'components/reports';

type ReportColumnProps = {
  onClose: () => void;
  permalink?: string;
  type?: string;
  reportData?: ReportResponse;
};

export const ReportColumn = ({
  onClose,
  permalink,
  type,
  reportData,
}: ReportColumnProps) => {
  const { isMobile } = useScreenSize();
  const { trackEventGA4 } = useContext(AppConfig);

  const handleReportRedirect = () => {
    trackEventGA4({
      event_name: CHATAI_GA4_EVENTS.name,
      type: CHATAI_GA4_EVENTS.report.type,
      sub_type: CHATAI_GA4_EVENTS.report.subTypes.open_report_in_new_tab,
    });
    if (type && permalink) {
      const reportUrl = `${constants.links.baseUrl}/report/${type}?permalink=${permalink}`;
      window.open(reportUrl, '_blank');
    }
  };

  return (
    <>
      <ReportColumnContainer
        direction="column"
        spacing={2}
        width={isMobile ? '100%' : '40%'}
        height="98%"
        sx={{
          ...(isMobile && {
            animation: 'fadeInScale 0.4s ease-out',
            '@keyframes fadeInScale': {
              '0%': {
                transform: 'scale(0.95)',
                opacity: 0,
              },
              '100%': {
                transform: 'scale(1)',
                opacity: 1,
              },
            },
          }),
        }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          position="sticky"
          top={0}
          zIndex={1}
          padding="16px 20px"
          sx={{
            backgroundColor: 'background.paper',
          }}
        >
          <Text variant="body1" fontWeight="bold" color="text.primary">
            Vehicle Report
          </Text>
          <Stack direction="row" spacing={2}>
            <OpenInNewIcon
              sx={{ color: 'text.secondary', cursor: 'pointer' }}
              onClick={handleReportRedirect}
            />
            <CloseIcon
              onClick={onClose}
              sx={{ color: 'text.secondary', cursor: 'pointer' }}
            />
          </Stack>
        </Stack>
        <ChatBVProvider width="100%">
          {type === SEARCH_TYPES.VEHICLE && permalink && reportData && (
            <ReportContextProvider permalink={permalink} reportType="vehicle">
              <VehicleReport permalink={permalink} preloadedData={reportData} />
            </ReportContextProvider>
          )}
        </ChatBVProvider>
      </ReportColumnContainer>
    </>
  );
};
